import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';

type KudosReasonsProps = {
  image: string;
  description: string;
  onClick: () => void;
  selected?: boolean;
};

const KudosReason = ({
  image,
  description,
  onClick,
  selected = false,
}: KudosReasonsProps) => (
  <button
    type="button"
    css={[
      baseButtonStyle,
      !selected && hoverButtonStyle,
      selected && selectedButtonStyle,
    ]}
    onClick={onClick}
  >
    <div css={selectedImageStyle}>
      <img src={image} />
    </div>
    <div css={descriptionStyle}>{description}</div>
  </button>
);

const baseButtonStyle = css({
  display: 'flex',
  width: '100%',
  boxSizing: 'border-box',
  padding: '12px 8px 14px 8px',
  alignItems: 'center',
  gap: '12px',
  cursor: 'pointer',
  borderRadius: '8px',
  border: `1px solid ${token('color.background.accent.gray.subtler')}`,
  backgroundColor: token('color.background.input'),
  color: token('color.text'),
  textOverflow: 'ellipsis',
  fontFamily: token('font.family.brand.body'),
  fontSize: token('font.size.300'),
  fontWeight: token('font.weight.semibold'),
  lineHeight: 'var(--Font-Body-Line-Height-Regular, 24px)',
  height: 'auto',
});

const hoverButtonStyle = css({
  ':hover': {
    borderRadius: '8px',
    border: `1px solid ${token('color.background.accent.gray.subtler')}`,
    background: token('color.background.input.hovered'),
  },
});

const selectedButtonStyle = css({
  border: `1px solid ${token('color.text.selected')}`,
  background: token('color.background.accent.blue.subtlest'),
});

const selectedImageStyle = css({
  display: 'flex',
  width: '46px',
  height: '46px',
  justifyContent: 'center',
  alignItems: 'center',
  flexShrink: 0,
});

const descriptionStyle = css({
  overflow: 'hidden',
  color: 'token("color.text")',
  textOverflow: 'ellipsis',
  textAlign: 'left',
  /* Body/Desktop/Regular */
  fontFamily: 'var(--Font-Family-Body, Inter)',
  fontSize: 'var(--Font-Body-Size-Regular, 16px)',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: 'var(--Font-Body-Line-Height-Regular, 24px)',
  width: '100%',
  height: 'auto',
  display: 'inline-block',
});

export default KudosReason;
